import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { GapEnum } from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { useTranslation } from 'react-i18next';

interface InformationCardComponentProps {
  network: GatewayNetworkModel;
}

export const InformationCardComponent = ({
  network,
}: InformationCardComponentProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.L}>
      <AccentTitle
        icon="map-01"
        as={HeadingEnum.H2}
        text={t('delmonicos-shared-sdk.outputs-network.description')}
      />
      <div>{network.description}</div>
    </Card>
  );
};
